var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { staticClass: "mr-1", attrs: { cols: "auto" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "ml-2",
              attrs: {
                link: "",
                small: "",
                outlined: "",
                color: "primary",
                to: {
                  name: `${_vm.link}`,
                },
                loading: _vm.loading,
                disabled: _vm.disabled,
              },
            },
            [_c("v-icon", [_vm._v("mdi-arrow-left")])],
            1
          ),
        ],
        1
      ),
      _c("v-col", [_c("h4", [_vm._v(" " + _vm._s(_vm.title) + " ")])]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }